import axios from 'axios'

// noinspection JSUnusedGlobalSymbols
export default {

    /* eslint no-empty-pattern: ["off"] */
    offerAvailableForVariantId({}, { variantId }) {
        return axios.post('/api/v1/mails/offer-available', { id: variantId })
    },

}
